"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const DeliverySettingAddress_1 = require("@/common/components/DeliverySetting/DeliverySettingAddress");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ userId, managingAddressId, isManageAddressInProgress, setIsManageAddressInProgress, disableInputMode, fetchAddressList, }) {
    const [isDeleting, setIsDeleting] = (0, react_1.useState)(false);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const deleteAddress = () => __awaiter(this, void 0, void 0, function* () {
        setIsManageAddressInProgress(true);
        setIsDeleting(true);
        const refetchAddressOnDelete = () => __awaiter(this, void 0, void 0, function* () {
            yield fetchAddressList();
            disableInputMode();
            setIsManageAddressInProgress(false);
        });
        yield (0, api_1.deleteData)(`/api/v1/members/${userId}/deliveries/${managingAddressId}`)
            .then(() => __awaiter(this, void 0, void 0, function* () {
            yield refetchAddressOnDelete();
        }))
            .catch(err => {
            var _a, _b, _c, _d;
            const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            if (errorStatus === 400 || errorStatus === 404) {
                (0, DeliverySettingAddress_1.handleManageAddressErrors)({ confirm, errorCode, concurrenceFn: refetchAddressOnDelete });
            }
            else if (errorStatus === 403)
                (0, errors_1.handle403Error)(err);
            else
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
            setIsManageAddressInProgress(false);
            setIsDeleting(false);
        });
    });
    const onDeleteAddressClick = () => __awaiter(this, void 0, void 0, function* () {
        confirm({
            description: t('배송지 정보를 삭제하시겠어요?'),
            confirmationText: t('삭제'),
        })
            .then(deleteAddress)
            .catch(() => { });
    });
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: isManageAddressInProgress, onClick: onDeleteAddressClick, sx: {
            width: '100%',
            height: '56px',
            p: '0px 8px',
            borderRadius: '12px',
            border: '1px solid var(--gray-10)',
            bgcolor: 'var(--white) !important',
            color: 'var(--gray-80) !important',
            fontSize: '18px',
        } }, { children: isDeleting ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 8 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('삭제') })) })));
}
exports.default = default_1;
